module.exports = __webpack_public_path__ + "img/cyberclass.8544bff2.svg";